
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/beef",
      function () {
        return require("private-next-pages/recipes/beef.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/beef"])
      });
    }
  